import { Component } from '@angular/core';

import { IToastData } from '@interfaces/toast.interface';

@Component({
  selector: 'app-warning-toast',
  templateUrl: './warning-toast.component.html',
  styleUrls: ['./warning-toast.component.scss']
})
export class WarningToastComponent implements IToastData {
  public data: any;
  public delay: number;
  public callback: (any) => any = (_) => {};
}
